export default {
  setSocketOnline({ commit }, payload) {
    commit("SET_ONLINE", payload);
  },
};
